import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { KF_API_CONFIG } from '../kf-api.config';


// providedIn: 'root' so an application that renders the shared shell does not have to know to
// provide this. Rexine lists it in an NgModule's providers as well, which resolves to the same
// root instance; a standalone application has no such list.
@Injectable({ providedIn: 'root' })
export class ApiHttpService {
  ApiUrl = inject(KF_API_CONFIG).apiUrl;
  constructor(public http: HttpClient) {

  }
  public get(url: string, options?: any) {
    return this.http.get(url, options);
  }
  public post(url: string, data: any, options?: any) {
    return this.http.post(url, data, options);
  } 
  
}
